import { CookieService } from './cookie.service';
export function cookieServiceFactory(cookieOptionsProvider) {
    return new CookieService(cookieOptionsProvider);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-cookie/src/cookie.factory.js
// module id = 489
// module chunks = 75